export const courierTrackingIntervals = [15, 30, 60] as const;
export interface CourierTrackingSchedule {
  enabled: boolean;
  interval_minutes: number;
  revision: number;
  next_check_at: string | null;
  ends_at: string | null;
  last_checked_at: string | null;
  failures: number;
  problem: string | null;
}
